import get from 'lodash-es/get'
import * as Yup from 'yup'

import { EMPTY_STRING } from '../../../../constants/common'
import { REG_EXP_EMAIL } from '../../../../constants/regExp'
import i18n from '../../../../i18n'

import {
  RECOVER_PASSWORD_FORM_FIELD_NAME_EMAIL,
  RECOVER_PASSWORD_FORM_SERVER_NON_FIELD_ERRORS,
} from './RecoverPasswordForm.constants'

export function getRecoverPasswordFormValidationSchema() {
  return Yup.object({
    [RECOVER_PASSWORD_FORM_FIELD_NAME_EMAIL]: Yup.string()
      .matches(
        REG_EXP_EMAIL,
        i18n.t('Error.RecoverPasswordFormInvalidEmailFormatKey')
      )
      .required(true),
  })
}

export function parseRecoverPasswordFormError(error) {
  const errorText = get(error, ['response', 'data', 'errors'], EMPTY_STRING)

  if (RECOVER_PASSWORD_FORM_SERVER_NON_FIELD_ERRORS[errorText]) {
    return i18n.t(RECOVER_PASSWORD_FORM_SERVER_NON_FIELD_ERRORS[errorText])
  }

  return errorText
}
